import { isDevMode, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// NgRX
import { StoreModule as NgRX } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NavigationActionTiming, RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { metaReducers, reducers } from './reducers';
import { DepreciationEffects } from '@core/store/effects/depreciation.effects';
import { WarrantyEffects } from '@core/store/effects/warranty.effects';
import { MaintainerEffects } from '@core/store/effects/maintainer.effects';
import { SessionEffects } from '@core/store/effects/session.effects';



@NgModule({
  declarations: [ ],
  imports: [
    CommonModule,
    NgRX.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([ SessionEffects, DepreciationEffects, WarrantyEffects, MaintainerEffects ]),
    StoreDevtoolsModule.instrument({ maxAge: 27, logOnly: !isDevMode() }),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'navegation',
      navigationActionTiming: NavigationActionTiming.PostActivation,
      routerState: RouterState.Minimal
    }),
  ]
})
export class StoreModule { }
